package com.castly.admin

import androidx.compose.runtime.*
import com.castly.admin.api.ApiClient
import com.castly.admin.ui.App
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

fun main() {
    val baseUrl = if (window.location.hostname == "localhost") {
        "http://localhost:8080"
    } else {
        "https://api-${window.location.hostname}"
    }

    val apiClient = ApiClient(baseUrl)

    renderComposable(rootElementId = "root") {
        App(apiClient)
    }
}
